import { LeaseRenewalOffer } from './LeaseRenewals';
import { PaymentOptions } from './PaymentOptions';
import { Property } from './Property';
import { Tenant } from './Tenant';
import { LeaseTransaction } from './Transaction';
import { Unit } from './Unit';

export enum LeaseStatus {
  Lease = 'lease',
  LeaseMonthToMonth = 'leaseMonthToMonth',
  MonthToMonth = 'monthToMonth',
  Eviction = 'eviction',
  Expired = 'expired',
  Draft = 'draft',
  Ended = 'ended',
  Future = 'future',
}

export interface Lease {
  id: string;
  unitId?: string;
  propertyId?: string;
  portfolioId?: string;
  start?: string;
  end?: string;
  ended?: string;
  monthToMonth?: boolean;
  eviction?: boolean;
  chatId?: string;
  tenants?: Tenant[];
  draft: boolean;
  status?: LeaseStatus;
  currentRent?: number;
  currentDeposit?: number;
  lastPaymentDate?: string;
  earliestUnpaidBillDue?: string;
  unit: Unit;
  property?: Property;
  securityDepositPaid?: number;
  securityDepositRequested?: number;
  securityDepositDue?: number;
  transactions?: LeaseTransaction[];
  deposits?: LeaseTransaction[];
  paymentOptions?: PaymentOptions;
  depositsPaymentOptions?: PaymentOptions;
  postedBalance: number;
  currentBalance: number;
  postedDepositBalance: number;
  currentDepositBalance: number;
  image?: string;
  thumbnail?: string;
  offers: LeaseRenewalOffer[];
}
